module.exports = __webpack_public_path__ + "static/media/cookieMarkerBrandRefresh.e93a229b.svg";